module.exports = __webpack_public_path__ + "static/media/whistle-dog-2024-dt-fr.e423d926.jpg";